// Used by the auth and storage emulators and localApi server proxy
const localIp = 'localhost';
export default localIp;
